<form>
  <div class="form-group">
    <label for="title">Title:</label>
    <input class="form-control" type="text" id="title" name="title" [(ngModel)]="QuestionSet.title" />
  </div>
  <div class="form-group">
      <label for="instructions">Instructions:</label>
      <textarea class="form-control h-100" id="instructions" name="instructions" [(ngModel)]="QuestionSet.instructions"></textarea>
  </div>
  <div class="form-group">
      <label for="answerStartValue">Answer Start Value:</label>
      <input class="form-control" type="number" id="answerStartValue" name="answerStartValue" [(ngModel)]="QuestionSet.answer_start_value" />
  </div>
  <!--<div class="form-group">
      <label for="displayOrder">Display Order:</label>
      <input class="form-control" type="number" id="displayOrder" name="displayOrder" [(ngModel)]="questionSet.display_order" />
  </div>-->
  <div class="form-group">
      <label for="display_type">Display Type:</label>
      <select class="form-control browser-default" id="display_type" name="display_type" name="display_type" [(ngModel)]="QuestionSet.display_type">
        <option value="MultipleChoiceGrid">Multiple Choice Grid</option>
        <option value="SingleSelectDropdown">Single Choice Dropdown</option>
        <option value="QuestionList">Question List</option>
      </select>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/admin/question-set-core-form/question-set-core-form.component.html